export default {
  tickets: 'Tickets',
  permissions: 'Permissions',
  warroom: 'War-Room',
  sac: 'Conversations',
  performance: 'Proprietary Metrics',
  modules: 'Modules',
};

